"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLoadingIndicator = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../product-editor/components/common");
exports.StyledLoadingIndicator = (0, styled_components_1.default)(common_1.ProcessingSpinner) `
  display: flex;
  justify-content: center;
  align-self: center;

  svg g path {
    fill: currentColor;
  }
`;
